module.exports = __webpack_public_path__ + "img/map_xinjiang.81426052.png";